import React, { useRef, useState, useLayoutEffect } from 'react'
import './products.css'
import { Button, Card, Col, Container, Row } from 'react-bootstrap'
import { Shadow } from '../../assets/images'
import Slider from 'react-slick'
import {Agentic_Cust,Embedded,Security,Financial,Copilot,Finance,Compliance,Hr,Student,Logistics,AI_powered } from '../../assets/images/index'
import ContactForm from '../contactus-popup/ContactForm'

const Products = () => {

    const caro = useRef(null)
    const [currentIndex, setCurrentIndex] = useState(0);
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    useLayoutEffect(() => {
        setInterval(() => {
            gotoNext()
        }, 7200);
    //   console.log(caro.current)
      return () => {}
    }, [])

const gotoNext = () => {
caro.current?.slickNext();
}
const Image = {
        dots: false,
        infinite: true,
      //   speed: 1000,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 0,
        arrows: false,
        fade: true,
        draggable:false
    };

    const products =[
      {
         image:Agentic_Cust
      },
       {
         image:Embedded
      },
       {
         image:Security
      },
       {
         image:Financial
      },
       {
         image:Copilot
      },
        {
         image:Finance
      },
        {
         image:Compliance
      },
         {
         image:Hr
      },
      {
         image:AI_powered
      },
         {
         image: Student
      },
        {
         image:Logistics
      },
    ]
return (
     <div id='products'>
     <Container>
      <Card className='product-card'>
         <div className='text-center'>
            <h1 className='product-title'>Products & Solutions</h1>
            <p className='product-subtitle'>Transforming industries with Agentic AI</p>
         </div>
         <Row className='pt-5'>
            <Col sm={12} md={12} lg={6}>
            <div className='product-list'>
               <ul className="product-list">
                  <li  className={currentIndex ===0 ? 'panel active' : 'panel'} onClick={()=>{caro.current?.slickGoTo(0)}} >Agentic Customer Support Assistants</li>
                  <li  className={currentIndex ===1 ? 'panel active' : 'panel'} onClick={()=>{caro.current?.slickGoTo(1)}}  >Embedded Generative AI in Workflows</li>
                  <li className={currentIndex ===2 ? 'panel active' : 'panel'} onClick={()=>{caro.current?.slickGoTo(2)}} >Autonomous Security Operations</li>
                  <li className={currentIndex ===3 ? 'panel active' : 'panel'} onClick={()=>{caro.current?.slickGoTo(3)}} >Autonomous Financial Process Agents</li>
                  <li className={currentIndex ===4 ? 'panel active' : 'panel'} onClick={()=>{caro.current?.slickGoTo(4)}} >Copilot for Enterprise Productivity</li>
                  <li className={currentIndex ===5 ? 'panel active' : 'panel'} onClick={()=>{caro.current?.slickGoTo(5)}} >Agentic AI in Finance & Risk</li>
                  <li className={currentIndex ===6 ? 'panel active' : 'panel'} onClick={()=>{caro.current?.slickGoTo(6)}} >Compliance Support Agents</li>
                  <li className={currentIndex ===7 ? 'panel active' : 'panel'} onClick={()=>{caro.current?.slickGoTo(7)}} >HR & Enterprise Operations Assistants</li>
                  <li className={currentIndex ===8 ? 'panel active' : 'panel'} onClick={()=>{caro.current?.slickGoTo(8)}} >AI‑Powered Business Intelligence </li>
                  <li className={currentIndex ===9 ? 'panel active' : 'panel'} onClick={()=>{caro.current?.slickGoTo(9)}} >AI Student Education App</li>
                  <li className={currentIndex ===10 ? 'panel active' : 'panel'} onClick={()=>{caro.current?.slickGoTo(10)}} >Logistics Intelligence</li>
               </ul>
            </div>
            </Col>
            <Col sm={6} md={12} lg={6} className='text-center sm-d-none'>
            <div   >
               <Slider    ref={caro} {...Image}
               beforeChange={(currentSlide, nextSlide) => {
               setCurrentIndex(nextSlide);
               console.log("currentSlide", currentSlide)
               }}>
                  {
                     products.map((item, index)=>{
                        return(
                           <div key={index} className='imag_box'>
                           <img className='imag_height' src={item.image} alt="img" />
                        </div>

                        )
                     })

                  }



               </Slider>
            </div>
            </Col>
         </Row>
      </Card>
      <div className='text-center pb-4 bg-card'>
         <h1 className='foot-title'>Want to accelerate <br /> your AI transformation?</h1>
         <p className='foot-description mt-5'>Discover how Triumphal helps enterprises move from <br></br>digital to autonomous with Agentic AI solutions.</p>
         <div className='polygon_btn_cont mt-5'>
            <Button className='polygon_btn bg-change' variant="outline-primary" onClick={handleShow}>Schedule a Call</Button>
            <div className='polygon_shadow'></div>
         </div>
      </div>
      <div className='text-center mb-5 md-d-none'>
         <img src={Shadow} alt="shadow" />
      </div>
   </Container>
   <ContactForm  show={show} onClose={handleClose}  onShow ={handleShow} />
</div>
    )
}

export default Products
